import React, { useState } from "react";
import { ChevronDown, ChevronRight, Download } from "lucide-react";

export const FlowchartViewer = ({ id, title, icon: Icon, blurb, pdf, pages }) => {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [slug, label] = pages[page];
  return (
    <div className="border border-amber-200 rounded-xl overflow-hidden bg-white" data-testid={`${id}-section`}>
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-amber-50/50" data-testid={`${id}-toggle`}>
        <span className="flex items-center gap-2 font-semibold text-slate-800"><Icon className="w-4 h-4 text-amber-600" />{title}</span>
        {open ? <ChevronDown className="w-5 h-5 text-slate-400" /> : <ChevronRight className="w-5 h-5 text-slate-400" />}
      </button>
      {open && (
        <div className="px-4 pb-5 pt-1 space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="text-sm text-slate-700">{blurb}</p>
            <a href={pdf} download className="inline-flex items-center rounded-md bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium px-3 py-2" data-testid={`${id}-download`}>
              <Download className="w-4 h-4 mr-2" />Download PDF
            </a>
          </div>
          <div className="flex flex-wrap gap-2" role="tablist">
            {pages.map(([s, l], i) => (
              <button key={s} role="tab" aria-selected={i === page} onClick={() => setPage(i)}
                className={`rounded-full px-3 py-1.5 text-xs font-semibold border transition-colors ${i === page ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-300 hover:border-amber-400"}`}
                data-testid={`${id}-tab-${s}`}>{l}</button>
            ))}
          </div>
          <img src={`/docs/flow/${slug}.svg`} alt={`Flowchart: ${label}`} className="w-full max-w-3xl mx-auto rounded-lg border border-slate-200 bg-white p-2" data-testid={`${id}-image`} />
        </div>
      )}
    </div>
  );
};
